import React from 'react';
import { useTranslation } from 'react-i18next';
import { getSolidBackgroundShade } from 'utils/ui';
import { Pill } from 'components/Pill';
import { jsx as _jsx } from "react/jsx-runtime";
function getStatusTranslationKey(status) {
  if (!status) {
    return 'state_not_booked';
  }
  switch (status) {
    case 'booked':
      {
        return 'state_booked';
      }
    case 'cancelled':
      {
        return 'state_cancelled';
      }
    case 'attended':
      {
        return 'state_attended';
      }
    case 'noshow':
      {
        return 'state_no_show';
      }
    default:
      {
        return 'state_not_booked';
      }
  }
}
function getStatusColor(status) {
  switch (status) {
    case 'booked':
    case 'attended':
      {
        return 'positive';
      }
    case 'cancelled':
    case 'noshow':
      {
        return 'negative';
      }
    default:
      {
        return 'neutral';
      }
  }
}
function EventStatusPill(_ref) {
  var status = _ref.status;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var label = t(getStatusTranslationKey(status));
  var statusColor = getStatusColor(status);
  return /*#__PURE__*/_jsx(Pill, {
    icon: "asset-event",
    iconColor: statusColor,
    background: getSolidBackgroundShade,
    children: label
  });
}
export default EventStatusPill;